var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectricCars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 84 72"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 16,
  r: 16,
  fill: "#0397D8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M62.9 16.5 68.89 8h4.23l-3.47 4.94h4.18L65.1 24.02l2.07-7.5h-4.26z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  fillRule: "evenodd",
  d: "m36.43 24 14.55 9.33h5.35l5 5.4v10.6h-4V40.3l-2.75-2.97H15.22l-3.27-5.14-5.28 3.27v13.87h-4v-16.1L17.56 24zm-20.68 5.83 2.08 3.5h6.73V28H18.7zm27.82 3.5H28.56V28h6.7zM10 48a6 6 0 1 1 12 0 6 6 0 0 1-12 0m8 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m30-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-9.33-.67H25.33v4h13.34z",
  clipRule: "evenodd"
})));
export { SvgElectricCars as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/ulez/electric-cars.svg", import.meta.url).toString();